import React from "react";
import { motion } from "framer-motion";
import { Building2, Users } from "lucide-react";
import { KENYA_AVERAGE_AGE, KENYA_GDP_PPP_RANGE, kenyaStats } from "../../constants/siteContent";
import { AnimatedNumber } from "../common/AnimatedNumber";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const KenyaStatsSection = () => {
  return (
    <section id="kenya" data-testid="kenya-section" className="py-24 md:py-28 bg-[#D1111A]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer} className="text-center mb-16 md:mb-[4.5rem]">
          <motion.p variants={fadeInUp} className="text-white/80 font-semibold tracking-[0.2em] uppercase mb-3">Kenya in Numbers</motion.p>
          <motion.h2 variants={fadeInUp} className="font-editorial text-4xl md:text-6xl text-white italic">The Opportunity</motion.h2>
        </motion.div>

        <motion.div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          {kenyaStats.map((stat, index) => (
            <motion.div key={stat.label} variants={fadeInUp} className="text-center p-7 md:p-8 bg-white/10 border border-white/14 backdrop-blur-sm" data-testid={`kenya-stat-${index}`}>
              <stat.icon className="w-10 h-10 text-white/80 mx-auto mb-4" />
              <div className="font-editorial text-5xl md:text-6xl text-white leading-none mb-2">
                <AnimatedNumber value={stat.number} suffix={stat.suffix || ""} duration={2000} />
              </div>
              <p className="text-white/90 uppercase tracking-wider text-sm font-medium">{stat.label}</p>
            </motion.div>
          ))}
          <motion.div variants={fadeInUp} className="text-center p-7 md:p-8 bg-white/10 border border-white/14 backdrop-blur-sm" data-testid="kenya-gdp-ppp-card">
            <Building2 className="w-10 h-10 text-white/80 mx-auto mb-4" />
            <div className="font-editorial text-4xl md:text-5xl text-white leading-none mb-3">{KENYA_GDP_PPP_RANGE}</div>
            <p className="inline-block border border-white/25 bg-white/10 px-4 py-2 text-white/90 uppercase tracking-wider text-sm font-medium">Kenya GDP PPP</p>
          </motion.div>

          <motion.div variants={fadeInUp} className="text-center p-7 md:p-8 bg-white/10 border border-white/14 backdrop-blur-sm" data-testid="kenya-average-age-card">
            <Users className="w-10 h-10 text-white/80 mx-auto mb-4" />
            <div className="font-editorial text-5xl md:text-6xl text-white leading-none mb-3">{KENYA_AVERAGE_AGE}</div>
            <p className="inline-block border border-white/25 bg-white/10 px-4 py-2 text-white/90 uppercase tracking-wider text-sm font-medium">Average Age of Kenya</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};